import { render, staticRenderFns } from "./Consumible.vue?vue&type=template&id=9bb548fa&scoped=true&"
import script from "./Consumible.vue?vue&type=script&lang=js&"
export * from "./Consumible.vue?vue&type=script&lang=js&"
import style0 from "./Consumible.vue?vue&type=style&index=0&id=9bb548fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb548fa",
  null
  
)

export default component.exports